export enum PaymentType {
  TransferToAccount = 'Prevodom na účet',
  InsertToAccount = 'Vkladom na účet',
}
